/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_Subscription_NoInputs */

const en_admin_subscriptions_subscription_no = /** @type {(inputs: Admin_Subscriptions_Subscription_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription No`)
};

/**
* | output |
* | --- |
* | "Subscription No" |
*
* @param {Admin_Subscriptions_Subscription_NoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_subscription_no = /** @type {((inputs?: Admin_Subscriptions_Subscription_NoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_Subscription_NoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_subscription_no(inputs)
});
export { admin_subscriptions_subscription_no as "admin.subscriptions.subscription_no" }